import React from "react";
import ComingSoonImage from "../../assets/images/comingsoon.png";

export default function ComingSoon() {
  return (
    <div
      style={{
        display: "flex",
        padding: "85px 24px 24px 24px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        flex: 1,
        height: "100vh",
      }}
    >
      <img
        style={{
          height: 100,
          width: 100,
        }}
        src={ComingSoonImage}
        alt="Coming Soon"
      />
      <h1 style={{ marginBottom: 0 }}>Coming Soon!</h1>
      <h2 style={{ marginBottom: 0 }}>We know this is not enough 😉</h2>
      <p>Please just use app for now, we will soon build this page</p>
    </div>
  );
}
